import { render, staticRenderFns } from "./AddressSettingPage.vue?vue&type=template&id=51a262f5&scoped=true"
import script from "./AddressSettingPage.vue?vue&type=script&lang=js"
export * from "./AddressSettingPage.vue?vue&type=script&lang=js"
import style0 from "./AddressSettingPage.vue?vue&type=style&index=0&id=51a262f5&prod&lang=scss&scoped=true"
import style1 from "./AddressSettingPage.vue?vue&type=style&index=1&id=51a262f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a262f5",
  null
  
)

export default component.exports